import { useFormDataContext } from "@totalenergiescode/mobility-business-rev-form-data/components";

import FormFieldDebugOverlay from "@/components/FormData/debug/overlay/FormFieldDebugOverlay";
import ViolationList from "@/components/FormData/debug/violations/ViolationList";
import {
  StyledFormFieldContainer,
  StyledFormFieldOverlay,
} from "@/components/FormData/lib/layout/Renderers/styles";
import TranslationFailureIndicator from "@/components/FormData/lib/layout/Renderers/TranslationFailureIndicator";

interface FormFieldRendererProps {
  fieldId: string;
  summary: boolean;
}

const FormFieldRenderer = ({ fieldId, summary }: FormFieldRendererProps) => {
  const {
    findFieldById,
    debug,
    decoratorStore: store,
    dataTestIdPrefix,
  } = useFormDataContext();

  const field = findFieldById(fieldId);

  const classes: string[] = [summary ? "field-summary" : "field-input"];

  if (!field.isValid()) {
    classes.push(field.hasViolations() ? "has-violation" : "is-required");
  }

  if (debug) {
    classes.push("field-debug");
  }

  return (
    <StyledFormFieldOverlay
      className={`field ${classes.join(" ")}`}
      $isDebug={debug}
      data-test-id={`${dataTestIdPrefix}${field.id()}${summary ? ".summary" : ""}`}
    >
      {summary ? (
        <>
          {/* Rendering as summary field */}
          {store.asSummary(field)}
        </>
      ) : (
        <>
          {/* Rendering as Input field */}
          <FormFieldDebugOverlay field={field} />
          <TranslationFailureIndicator targetId={field} />
          <StyledFormFieldContainer>
            <>{store.asInput(field)}</>
          </StyledFormFieldContainer>
          <ViolationList field={field} />
        </>
      )}
    </StyledFormFieldOverlay>
  );
};

export default FormFieldRenderer;
